module.exports = __webpack_public_path__ + "static/media/despertarspa.a49ac881.gif";